import { Modal, SubmitButton } from "@xola/ui-kit";
import React from "react";
import { useMutation } from "react-query";
import { Resource } from "types";
import { api } from "../../../api/api";
import { useInvalidate } from "../../../hooks/useInvalidation";
import { SecondaryButton } from "../../Common/SecondaryButton";

interface DeleteEquipmentModalProps {
    onClose: () => void;
    isOpen: boolean;
    resource: Resource;
}

export const DeleteEquipmentModal = ({ resource, onClose, isOpen }: DeleteEquipmentModalProps) => {
    const invalidate = useInvalidate();

    const { mutateAsync: deleteResource, isLoading } = useMutation(async (resource: Resource) => {
        const response = await api.delete(`/resources/${resource.id}`);
        invalidate("resources");
        return response;
    });

    const handleConfirm = async () => {
        try {
            await deleteResource(resource);
            onClose();
        } catch {
            // We do nothing. On error keep modal open.
        }
    };

    return (
        <Modal shouldCloseOnOutsideClick size="medium" isOpen={isOpen} onClose={onClose}>
            <Modal.Header>Confirm Delete</Modal.Header>
            <Modal.Body>
                <p className="p1">Are you sure you want to delete?</p>
            </Modal.Body>
            <Modal.Footer className="space-x-4">
                <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
                <SubmitButton color="danger" isLoading={isLoading} onClick={handleConfirm}>
                    Confirm
                </SubmitButton>
            </Modal.Footer>
        </Modal>
    );
};
